import Vue from 'vue'

// 下载
export const downLoadByBlob = (res) => {
  console.log(res, 'res')
  if (res.data.type === 'application/json') {
    downLoadErrorByBlob(res.data)
    return null
  }

  if (
    !res.headers['content-disposition'] &&
    !res.headers['Content-Disposition']
  ) {
    // createMessage.error('下载失败');
    return
  }
  const contentDisposition = decodeURIComponent(
    res.headers['content-disposition'] || res.headers['Content-Disposition']
  ) // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;

  const patt = new RegExp('filename\\*=([^;]+\\.[^\\.;]+);*')
  const result = patt.exec(contentDisposition)
  const params = result[1].split("'")
  const filename = params[params.length - 1]
  const fileNameList = filename.split('.')
  const suffix = fileNameList[fileNameList.length - 1]
  const typeEumn = {
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
    xls: 'application/vnd.ms-excel;charset=utf-8',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  }
  const blob = new Blob([res.data], {
    type: typeEumn[suffix]
  })
  const downloadElement = document.createElement('a')
  const href = window.URL.createObjectURL(blob)

  downloadElement.style.display = 'none'
  downloadElement.href = href
  downloadElement.download = filename // 下载后文件名
  document.body.appendChild(downloadElement)

  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}

export const downLoadErrorByBlob = (data) => {
  const fileReader = new FileReader()
  fileReader.onload = function () {
    try {
      const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败

      Vue.prototype.$Message.error(jsonData.error)
    } catch (err) {
      // 解析成对象失败，说明是正常的文件流
    }
  }
  fileReader.readAsText(data)
}
